(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[521],{

/***/ 1233:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about",
      function () {
        return __webpack_require__(8051);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _src_components_background__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5874);
/* harmony import */ var _src_components_layout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5962);
/* harmony import */ var _public_images_credit_bg_jpg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2133);
/* harmony import */ var _about_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9232);
/* harmony import */ var _about_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_about_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _src_components_popup__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9255);
/* harmony import */ var _src_components_arrowButton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1469);
/* harmony import */ var _src_components_actions_default_click__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7869);
/* harmony import */ var _src_components_actions_default_hover__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9148);
/* harmony import */ var _src_components_icons_question__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7350);












function About(param) {
    var dataAudio = param.dataAudio;
    var _this = this;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var bgData = {
        bgImage: _public_images_credit_bg_jpg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z
    };
    var pageData = {
        title: "אודות הפרויקט",
        content: '<p>ברוכים הבאים לתערוכה הוירטואלית "במסתרים", התערוכה מיועדת בעיקר לגילאי 12-15. עמוד הדרכה זה מיועד לכם, על מנת להציע לכם הכרות עם מבנה התערוכה ולאפשר לכם להדריך את ילדכם לפני ובמהלך הביקור בה.</p><p>אנו ממליצים לכם כמובן לחוות את התערוכה בעצמכם, לפני או יחד עם ילדכם. אם ילדכם עדיין אינו בן שתים עשרה, נוכחותכם יחד איתו חשובה עוד יותר.</p>',
        popButton1: {
            text: "מהי תערוכה וירטואלית ואינטראקטיבית?",
            type: "2",
            popup: "popup1"
        },
        popButton2: {
            text: 'מדוע בחרנו בנושא "ילדי מסתור"?',
            type: "2",
            popup: "popup2"
        },
        popButton3: {
            text: "מבנה התערוכה",
            type: "2",
            popup: "popup3"
        },
        pageButton: {
            color: "#223A57",
            text: "להורים ומורים"
        }
    };
    var popupData = {
        popup1: {
            title: "מהי תערוכה וירטואלית ואינטראקטיבית?",
            content: "<p>תערוכה ויזואלית מציגה תוכן בשילוב של תצלומים, איורים וסרטים, כדי לקרב את הלומד למציאות ולחוות את הנושא בכל חושיו.</p><p>כאשר התערוכה היא גם אינטראקטיבית, היא מאפשרת ללומד להיות חלק פעיל בתהליך הלמידה: לבחור בעצמו מה מענין אותו, לנוע מנושא לנושא, להתעכב או לקצר.</p>",
            type: "info",
            id: 1
        },
        popup2: {
            title: 'מדוע בחרנו בנושא "ילדי מסתור"?',
            content: "<p>התערוכה פונה לנוער צעיר, ולכן חיפשנו דמויות שדומות להם ככל האפשר - דמויות של ילדים וילדות.</p><p>ההזדהות של המבקרים עם גיבורי התערוכה מאפשרת סקרנות וענין, אך בעיקר יוצרת הזדהות וקשר בין הסיפורים מהעבר לחיינו כיום.</p>",
            type: "info",
            id: 2
        },
        popup3: {
            title: "מבנה התערוכה",
            content: '<p>פתיחה:</p><p>בפתיחת התערוכה מוצג סרטון אנימציה קצר המתאר את סיפורן האישי של שתי ילדות מסתור. הסיפור מבוסס על מאגר עדויות של ילדי מסתור במזרח אירופה וילדי מסתור במערב אירופה. הוא משקף את מצבם הנפשי והרגשי של הילדים, וגם את פעילותם ורגשותיהם של הדמויות שהיו שותפות לתהליך המסתור: ההורים, המצילים ופעילי ההצלה לפני ההבאה למסתור, במסתור וגם לאחר השחרור.</p><p>מטרתו של הסרטון היא ליצור הזדהות רגשית עם ילדי המסתור, כדי שהילד המבקר יחוש שילדי השואה לא היו "ילדים בשחור לבן" מתמונות עמומות, אף לא קשישים המעידים במבטא כבד על מאורעות חייהם, אלא ילדים כמוהו שעברו מאורעות קשים ושרדו אותם בגבורה, מתוך האחזות בזהות היהודית שלהם ובאמונה קיבלו מבית הוריהם.</p><br/><p>גוף התערוכה מחולק לארבעה חלקים:</p><p>הפרק הראשון – "המשפחה והפרידה" - עוסק בשנות המלחמה הראשונות (1939-1942), ובהחלטה הקשה למסור את הילדים למסתור. במהלך הפרק הודגשה המסירות האדירה והאהבה העמוקה של ההורים, שנצמדו לילדיהם כל עוד הדבר היה אפשרי אך נאלצו להיפרד מהם על מנת להציל אותם. כמו כן הוקדש חלק מסוים לתיאור החיים לפני המלחמה כחיים של ילדים נורמטיבים.</p><p>הפרק השני – "המסתור" מתאר את שנות המסתור עצמן (1942-1945). במהלך הפרק הלומד יכיר סוגי מסתור שונים, ויבין את הקשיים האופייניים לכל צורת מסתור. בפרק זה יש מקום להתמודדות הרוחנית של הילדים והקושי בשמירה על הזהות היהודית בתוך סביבה גויית עוינת.</p><p>הפרק השלישי - "הפדיון" - מתמקד במאמצים האדירים שהקדישו יהודים אחרי המלחמה למציאת ילדי מסתור אלו. הפרק מתאר דרכים שונות שפודי הילדים נקטו בהם, על מנת שלא להשאיר אף ילד יהודי בידיים זרות. הערבות היהודית המרגשת של הפודים מקבלת מקום בהסכתים קצרים המתארים כמה מחוויותיהם בגוף ראשון. יחד עם זאת מוצג גם המידע על כך שלמרבה הצער, הילדים שנפדו היו רק מיעוט מתוך הילדים שהוסתרו.</p><p>הפרק האחרון - "השיקום" - מוקדש לתיאור התהליך שעברו הילדים לאחר שובם לחיק העם היהודי. חשוב להבין את מצבם לאחר השואה, את התהליך שעברו ואת המאמץ שעשו אלו שהיו בסביבתם כדי להעניק להם חינוך וחום – משהו מילדותם העשוקה, ולקשור אותם מחדש לעם היהודי, לתורה ולמצוות.</p><p>בסיום התערוכה מוצגות מספר גלויות הסוגרות את סיפורן של הילדות מהסרט שפתח את התערוכה. מטרתו של הסיום היא להזכיר כי סיפורם של הילדים לא הסתיים: הוא המשיך בכך שהם בנו את חייהם מחדש, וממשיך עד היום בדמותם של ילדיהם ונכדיהם.</p>',
            type: "info",
            id: 3
        }
    };
    // Popup Function
    var openPopup = function(ID, element) {
        //console.log(element);
        var popup = document.getElementById(ID);
        if (popup.classList.contains("active")) {
            popup.classList.remove("active");
        } else {
            popup.classList.add("active");
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_src_components_layout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        header: "show",
        footer: "hide",
        audio: dataAudio,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "robots",
                    content: "noindex"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "vertical-wrapper relative h-screen w-screen z-10 overflow-hidden flex flex-nowrap flex-row-reverse ".concat((_about_module_scss__WEBPACK_IMPORTED_MODULE_11___default().container)),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_background__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        data: bgData,
                        moveBG: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "v-section w-screen h-auto z-50 flex content-center justify-center ".concat((_about_module_scss__WEBPACK_IMPORTED_MODULE_11___default().wrapper)),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "".concat((_about_module_scss__WEBPACK_IMPORTED_MODULE_11___default().content)),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                        children: pageData.title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "".concat((_about_module_scss__WEBPACK_IMPORTED_MODULE_11___default().text)),
                                        dangerouslySetInnerHTML: {
                                            __html: pageData.content
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "".concat((_about_module_scss__WEBPACK_IMPORTED_MODULE_11___default().buttonsGroup)),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "flex justify-start w-full ".concat((_about_module_scss__WEBPACK_IMPORTED_MODULE_11___default().magnetic)),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                    onClick: function() {
                                                        var ref;
                                                        openPopup(pageData === null || pageData === void 0 ? void 0 : (ref = pageData.popButton1) === null || ref === void 0 ? void 0 : ref.popup, _this);
                                                        (0,_src_components_actions_default_click__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
                                                    },
                                                    onMouseEnter: function() {
                                                        (0,_src_components_actions_default_hover__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)();
                                                    },
                                                    className: "poplink flex items-center flex-row-reverse ".concat((_about_module_scss__WEBPACK_IMPORTED_MODULE_11___default().buttonInfo)),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: (_about_module_scss__WEBPACK_IMPORTED_MODULE_11___default().iconText),
                                                            children: pageData === null || pageData === void 0 ? void 0 : (ref = pageData.popButton1) === null || ref === void 0 ? void 0 : ref.text
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                            className: "flex items-center justify-center ".concat((_about_module_scss__WEBPACK_IMPORTED_MODULE_11___default().icon)),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: (_about_module_scss__WEBPACK_IMPORTED_MODULE_11___default().after)
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_icons_question__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "flex justify-start w-full ".concat((_about_module_scss__WEBPACK_IMPORTED_MODULE_11___default().magnetic)),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                    onClick: function() {
                                                        var ref;
                                                        openPopup(pageData === null || pageData === void 0 ? void 0 : (ref = pageData.popButton2) === null || ref === void 0 ? void 0 : ref.popup, _this);
                                                        (0,_src_components_actions_default_click__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
                                                    },
                                                    onMouseEnter: function() {
                                                        (0,_src_components_actions_default_hover__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)();
                                                    },
                                                    className: "poplink flex items-center flex-row-reverse ".concat((_about_module_scss__WEBPACK_IMPORTED_MODULE_11___default().buttonInfo)),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: (_about_module_scss__WEBPACK_IMPORTED_MODULE_11___default().iconText),
                                                            children: pageData === null || pageData === void 0 ? void 0 : (ref1 = pageData.popButton2) === null || ref1 === void 0 ? void 0 : ref1.text
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                            className: "flex items-center justify-center ".concat((_about_module_scss__WEBPACK_IMPORTED_MODULE_11___default().icon)),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: (_about_module_scss__WEBPACK_IMPORTED_MODULE_11___default().after)
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_icons_question__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "flex justify-start w-full ".concat((_about_module_scss__WEBPACK_IMPORTED_MODULE_11___default().magnetic)),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                    onClick: function() {
                                                        var ref;
                                                        openPopup(pageData === null || pageData === void 0 ? void 0 : (ref = pageData.popButton3) === null || ref === void 0 ? void 0 : ref.popup, _this);
                                                        (0,_src_components_actions_default_click__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
                                                    },
                                                    onMouseEnter: function() {
                                                        (0,_src_components_actions_default_hover__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)();
                                                    },
                                                    className: "poplink flex items-center flex-row-reverse ".concat((_about_module_scss__WEBPACK_IMPORTED_MODULE_11___default().buttonInfo)),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: (_about_module_scss__WEBPACK_IMPORTED_MODULE_11___default().iconText),
                                                            children: pageData === null || pageData === void 0 ? void 0 : (ref2 = pageData.popButton3) === null || ref2 === void 0 ? void 0 : ref2.text
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                            className: "flex items-center justify-center ".concat((_about_module_scss__WEBPACK_IMPORTED_MODULE_11___default().icon)),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: (_about_module_scss__WEBPACK_IMPORTED_MODULE_11___default().after)
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_icons_question__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute direction-rtl z-50 ".concat((_about_module_scss__WEBPACK_IMPORTED_MODULE_11___default().button)),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_arrowButton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    onClick: function() {
                                        (0,_src_components_actions_default_click__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
                                    },
                                    onMouseEnter: function() {
                                        (0,_src_components_actions_default_hover__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)();
                                    },
                                    className: "p-5",
                                    link: "/about/parents-and-teachers/",
                                    color: pageData === null || pageData === void 0 ? void 0 : (ref3 = pageData.pageButton) === null || ref3 === void 0 ? void 0 : ref3.color,
                                    textColor: pageData === null || pageData === void 0 ? void 0 : (ref4 = pageData.pageButton) === null || ref4 === void 0 ? void 0 : ref4.color,
                                    text: pageData === null || pageData === void 0 ? void 0 : (ref5 = pageData.pageButton) === null || ref5 === void 0 ? void 0 : ref5.text
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_popup__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                popupID: "popup1",
                data: popupData.popup1
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_popup__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                popupID: "popup2",
                data: popupData.popup2
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_popup__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                popupID: "popup3",
                data: popupData.popup3
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (About);


/***/ }),

/***/ 5874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(458);
/* harmony import */ var gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _background_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7820);
/* harmony import */ var _background_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_background_module_scss__WEBPACK_IMPORTED_MODULE_4__);





function BackgroundImage(param) {
    var data = param.data, moveBG = param.moveBG, classes = param.classes, bgcolor = param.bgcolor, position = param.position;
    var ref, ref1, ref2, ref3;
    // Animations
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_3__.gsap.set(".section-bg", {
            scale: 1.4,
            opacity: 0
        });
        if (moveBG !== "no") {
            gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_3__.gsap.to(".section-bg", {
                scale: 1.2,
                opacity: 1,
                ease: "power.out",
                duration: 1,
                delay: 0
            });
        } else {
            gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_3__.gsap.to(".section-bg", {
                scale: 1,
                opacity: 1,
                ease: "power.out",
                duration: 1,
                delay: 0
            });
        }
        // Background Animation
        //console.log(moveBG);
        if (moveBG !== "no") {
            var parallaxIt = function parallaxIt(e, target, movement) {
                var relX = e.pageX - container.offsetLeft;
                var relY = e.pageY - container.offsetTop;
                gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_3__.gsap.to(target, 1, {
                    x: (relX - container.offsetWidth / 2) / container.offsetWidth * movement,
                    y: (relY - container.offsetHeight / 2) / container.offsetHeight * movement
                });
            };
            var container = document.querySelector(".body");
            container.addEventListener("mousemove", function(e) {
                parallaxIt(e, ".section-bg", -30);
            //parallaxIt(e, ".bg-mask1", -50);
            });
        }
    }, [
        moveBG
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            style: {
                backgroundColor: bgcolor
            },
            className: "section-bg ".concat((_background_module_scss__WEBPACK_IMPORTED_MODULE_4___default().sectionBG), " ").concat(position !== "fixed" ? "absolute" : "fixed", " left-0 top-0 w-screen h-screen z-10 ").concat(classes),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                className: "block object-cover object-center w-full h-full",
                src: data === null || data === void 0 ? void 0 : (ref = data.bgImage) === null || ref === void 0 ? void 0 : ref.src,
                height: data === null || data === void 0 ? void 0 : (ref1 = data.bgImage) === null || ref1 === void 0 ? void 0 : ref1.height,
                width: data === null || data === void 0 ? void 0 : (ref2 = data.bgImage) === null || ref2 === void 0 ? void 0 : ref2.width,
                blurDataURL: data === null || data === void 0 ? void 0 : (ref3 = data.bgImage) === null || ref3 === void 0 ? void 0 : ref3.blurDataURL,
                placeholder: "blur",
                alt: "Section BG"
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (BackgroundImage);


/***/ }),

/***/ 9232:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"about_container__FyjFu","wrapper":"about_wrapper__RWQSA","content":"about_content__hp3VY","text":"about_text__Nl3et","buttonsGroup":"about_buttonsGroup__w9MaI","magnetic":"about_magnetic__lo1Hm","buttonInfo":"about_buttonInfo__ITY9O","icon":"about_icon__FGOZa","after":"about_after__mtAlF","button":"about_button__jJUK5"};

/***/ }),

/***/ 7820:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sectionBG":"background_sectionBG__8doep"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [362,428,962,680,45,774,888,179], function() { return __webpack_exec__(1233); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);